<template>
    <div class="plan_item">
        <div class="plan_item__text">
            <div>
                <svg v-if="selected" class="link_icon">
                    <use xlink:href="@/assets/icons/check_green.svg#check_green"></use>
                </svg>
                <svg v-else class="link_icon">
                    <use xlink:href="@/assets/icons/check.svg#check"></use>
                </svg>
            </div>
            <span>{{ text }}</span>
        </div>
        <div class="info">
            <svg class="link_icon">
                <use xlink:href="@/assets/icons/info.svg#info"></use>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'plan-item-include',
    props: {
        text: String,
        selected: {
            type: Boolean,
            default: false
        }
    },
}
</script>

<style lang="scss" scoped>
.plan_item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__text {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 24px;
    }
}
.info {
    margin-left: 5px;
}
</style>